import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControlEncuesService {

  constructor(
    private http: HttpClient
  ) { }


  getControlEncuestaItbm(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getControlEncuesta,datos);
  }
  getInstitutos() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
  }

  getYearsArray() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getYearsArray);
  }

 getProductsArray() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos);
  }

  updateFlagControlSurvey(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateFlagControlSurvey,datos);
  }

}
